/**
 * Sentinel used to seed required URL/text fields on freshly-created content
 * modules. The backend's per-type validators require a string of length ≥ 1
 * (e.g. `image_url`, `file_url`, `meeting_url`), but the user hasn't uploaded
 * or typed anything yet — so we post a recognisable placeholder and content
 * editors treat it as "empty" (show the DropZone / empty input).
 *
 * Once the user provides a real value, the autosave overwrites this with the
 * actual URL/text and the sentinel is gone.
 */
export const PENDING_PLACEHOLDER = '__pending__';

export function isPending(value: unknown): boolean {
  return value === PENDING_PLACEHOLDER;
}

/** Treat either falsy OR the sentinel as "not set yet". */
export function isEmpty(value: unknown): boolean {
  return !value || isPending(value);
}
